export default __webpack_public_path__ + "static/media/data-report.c7db4598.svg";